//
//
//
//
//

export default {
  props: ["blok"]
};
